import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import isNil from 'ramda/src/isNil';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';

const SearchResult = ({ topics, search, onCancel, onSearch, categoryId, departments }) => {
    const navigate = useNavigate();
    const { current_page, data, last_page, per_page } = topics;

    const department = categoryId?.map((item) => {
        const dept = find(propEq('id', isNil(categoryId) ? null : item), departments);
        return dept;
    });

    return (
        <div className="topic-search-result">
            <div className="d-h-start flex-wrap  py-2 mb-3">
                {search && (
                    <div className="search-chip" onClick={onCancel('search')}>
                        <span className="dsl-b14">{search}</span>
                        <Icon name="fas fa-xmark cursor-pointer ms-2" color="#343f4b" size={14} />
                    </div>
                )}
                {department &&
                    department.map((item, index) => (
                        <div key={index} className="search-chip" onClick={onCancel(item.id)}>
                            <span className="dsl-b14">{item.name}</span>
                            <Icon name="fas fa-xmark cursor-pointer ms-2" color="#343f4b" size={14} />
                        </div>
                    ))}
            </div>
            {data?.length > 0 ? (
                <>
                    {data.map((item) => {
                        const { id, name, categories, comments, stats } = item;
                        const authorName = `${comments[0]?.user?.first_name} ${comments[0]?.user?.last_name}`;
                        const categoryId = categories[0].id;
                        const categoryName = categories[0].name;
                        return (
                            <div className="forum" key={id} onClick={() => navigate(`/community/forums/${id}/${categoryId}`)}>
                                <Avatar name={authorName} url={comments[0]?.author_avatar} isSponsored={true} />
                                <div className="d-flex ms-4 w-100">
                                    <div className="d-flex flex-column d-flex-7">
                                        <span className="dsl-b16 bold me-3">{name}</span>
                                        <div className="d-flex mt-1">
                                            <div className="d-flex ai-center me-3">
                                                <span className="dsl-m12 text-400 me-1">Created by</span>
                                                <span className="dsl-b14">{authorName}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="dsl-m12 text-400 me-2 mb-1">{categoryName}</div>
                                        <div className="d-h-center">
                                            <Icon name="far fa-eye me-2 text-500" size={12} color="#969faa" />
                                            <span className="dsl-d14 text-400 me-4">{stats?.views || 0}</span>
                                            <Icon name="fas fa-thumbs-up me-2 text-500" size={12} color="#969faa" />
                                            <span className="dsl-d14 text-400 me-3">{stats?.likes || 0}</span>
                                            <Icon name="far fa-comment me-2 text-500" size={12} color="#969faa" />
                                            <span className="dsl-d14 text-400">{stats?.comments || 0}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <div className="d-h-start">
                        <Pagination current={current_page} per={per_page} pers={[]} total={last_page} onChange={onSearch} />
                    </div>
                </>
            ) : (
                <div className="dsl-b16 text-center pb-3">No search result available</div>
            )}
        </div>
    );
};

SearchResult.propTypes = {
    topics: PropTypes.shape({
        current_page: PropTypes.number,
        data: PropTypes.array,
        last_page: PropTypes.number,
        per_page: PropTypes.number,
    }),
    search: PropTypes.string,
    onCancel: PropTypes.func,
    onSearch: PropTypes.func,
};

SearchResult.defaultProps = {
    topics: {
        current_page: 1,
        data: [],
        last_page: 1,
        per_page: 10,
    },
    search: '',
    onCancel: () => {},
    onSearch: () => {},
};

export default SearchResult;
